import { atom } from 'jotai';

export const atomFreeTrial = atom({
  isBlocked: false,
  counter: 0,
  showExtendsDemoButton: false,
  showCounter: false,
});
